import { type AuditTrailGroup, type AuditTrailResponse } from '@app/queries/auditTrail/leadAuditTrail';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AuditTrailState {
  auditTrails: AuditTrailGroup[];
  paginationConfig: {
    hasNextPage: boolean;
    endCursor?: string;
  };
  filterConfig: {
    sortOrder: 'asc' | 'desc';
    limit: number;
  };
  leadUuid?: string;
}

const initialState: AuditTrailState = {
  auditTrails: [],
  paginationConfig: {
    hasNextPage: true,
    endCursor: undefined,
  },
  filterConfig: {
    sortOrder: 'desc',
    limit: 5,
  },
  leadUuid: undefined,
};

export const auditTrailsTabSlice = createSlice({
  name: 'auditTrailsTab',
  initialState,
  reducers: {
    resetLoadedAuditTrails: (state) => {
      state.auditTrails = initialState.auditTrails;
      state.paginationConfig = initialState.paginationConfig;
      state.leadUuid = initialState.leadUuid;
    },
    validateAndResetLoadedTasks: (state, action: PayloadAction<string>) => {
      if (state.leadUuid !== action.payload) {
        auditTrailsTabSlice.caseReducers.resetLoadedAuditTrails(state);
      }
    },
    addLoadedAuditTrails: (state, action: PayloadAction<{ auditTrailData: AuditTrailResponse; leadUuid: string }>) => {
      const { auditTrailData, leadUuid } = action.payload;
      const {
        auditTrailGroup,
        pageInfo,
      } = auditTrailData.auditTrails;

      if (state.leadUuid !== leadUuid) {
        auditTrailsTabSlice.caseReducers.resetLoadedAuditTrails(state);
      }

      const currentGroupIds = new Set(state.auditTrails.map((group) => group.id));
      state.auditTrails = [...state.auditTrails, ...auditTrailGroup.filter((group) => !currentGroupIds.has(group.id))];
      state.paginationConfig = pageInfo;
      state.leadUuid = leadUuid;
    },
  },
});

export const {
  resetLoadedAuditTrails,
  addLoadedAuditTrails,
  validateAndResetLoadedTasks,
} = auditTrailsTabSlice.actions;

export default auditTrailsTabSlice.reducer;
